define('common/config/cookieAccessors',{
    raw: {
        session: ['kazumoSession'],
        mediumTerm: ['kazumoMedium', 30],
        longTerm: ['kazumo', 365]
    },
    keyValue: {
        abTestSplashPageShownStorage: 'mediumTerm',
        splashPageShownStorage: 'mediumTerm',
        actionedPageModule: 'session',
        deviceInfo: 'longTerm',
        fingerprintV2: 'longTerm',
        marketCode: 'longTerm',
        referrerInfo: 'mediumTerm',
        preSelectedWelcomeOfferId: 'session',
        selectedWelcomeOfferId: 'session',
        targetCampaignId: 'session',
        testSubjectId: 'mediumTerm',
        tournamentsWelcome: 'mediumTerm',
        appInfo: 'longTerm',
        numberOfVisits: 'longTerm',
        startedRegistration: 'session'
    }
});

